import { Icon } from "armstrong-react";
import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import { GoogleAnalyticsHelper } from "@travellocal/ui";
import * as StringUtil from "@travellocal/utils/stringHelpers";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import "./countryGallery.scss";

interface StateProps {
  country: IState<ICountry>;
}

interface DispatchProps {
  imageClicked: (countrySlug: string, fileName: string, regionSlug: string) => void;
}

type Props = DispatchProps & StateProps;

export class CountryGalleryComponent extends React.Component<Props, {}> {
  private imageClicked(countrySlug: string, fileName: string, regionSlug: string): void {
    GoogleAnalyticsHelper.logEvent("Image Gallery", "Click", "Open Gallery");
    this.props.imageClicked(countrySlug, fileName, regionSlug);
  }
  public render() {
    const country = this.props.country.data;

    return (
      <div className="width-wrapper p-top-medium p-bottom-medium country-gallery">
        <Helmet
          title={this.props.country.data.galleryPageTitleTag}
          meta={[
            { name: "description", content: this.props.country.data.galleryPageDescriptionTag },
          ]}
          link={[
            {
              rel: "canonical",
              href: `${globalConfig.wwwBaseUrl}${WebRoutes.countryGallery(country.slug, country.parent.slug)}`,
            },
          ]}
        />

        {this.props.children}

        <p className="info-box"><Icon icon={Icon.Icomoon.info2} /> Click or tap on an image to see it fullscreen</p>

        <div className="columns is-multiline">
          {(country.images || [])
            .filter(x => !x.locationImageType)
            .map(image => (
              <div
                className="column is-6-tablet is-4-desktop is-3-widescreen gallery-image"
                key={`country-image-${image.id}`}
              >
                <img
                  src={image.thumbnailUrl}
                  alt={image.meta}
                  title={StringUtil.truncate(image.description, 75)}
                  onClick={() => this.imageClicked(country.slug, image.fileName, country.parent.slug)} />
              </div>
            ))}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    imageClicked: (countrySlug: string, fileName: string, regionSlug: string) =>
      dispatch(push(WebRoutes.countryGalleryImage(countrySlug, fileName, regionSlug))),
  };
};

const mapStateToProps = (state: IWebStoreState) => {
  return {
    country: state.country,
  };
};

export const Gallery = connect(mapStateToProps, mapDispatchToProps)(CountryGalleryComponent);
